import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Log } from 'ng2-logger';
import { MaintenancePlan } from '@app/shared/models/maintenancePlan.model';
import { TableConfig } from '@app/shared/util/table-config.utils';

@Component({
  selector: 'app-maintenance-plans-table',
  templateUrl: './maintenance-plans-table.component.html',
  styleUrls: ['./maintenance-plans-table.component.scss']
})
export class MaintenancePlansTableComponent {
  _logger = Log.create(MaintenancePlansTableComponent.name);

  @Input() maintenancePlans: MaintenancePlan[];
  @Input() tableConfig: TableConfig;
  @Input() isLoading: false;
  @Input() headerBackgroundColor: string;

  @Output() pageChange = new EventEmitter<any>();
  @Output() filterChange = new EventEmitter<any>();
  @Output() sortChange = new EventEmitter<any>();
  @Output() rowClick = new EventEmitter<any>();
  @Output() openNewPage = new EventEmitter<any>();

  constructor() { }

  onPageChange(tableConfig: TableConfig) {
    this._logger.info('onPageChange::', tableConfig);
    this.pageChange.emit(tableConfig);
  }

  onOpenNewPage($event: any) {
    this.openNewPage.emit($event)
  }

  onSortChange(tableConfig: TableConfig) {
    this._logger.info('onSortChange::', tableConfig);
    this.sortChange.emit(tableConfig);
  }

  onFilterChange(tableConfig: TableConfig) {
    this._logger.info('onFilterChange::', tableConfig);
    this.filterChange.emit(tableConfig);
  }

  onRowClick(clickedItem) {
    this._logger.info('onRowClick::', clickedItem);
    this.rowClick.emit(clickedItem);
  }
}
